var map = {
	"./2020Vision_abyssWithinMe_55.webp": 5365,
	"./2020Vision_canYouSeeMe_55.webp": 60360,
	"./2020Vision_undertheMidnightSun_55.webp": 87593,
	"./2020Vision_wordandaRing_55.webp": 23886,
	"./ainaWassvik_dauntless_55.webp": 90162,
	"./ainaWassvik_hypnotized_55.webp": 66269,
	"./audunHaukvik_drivingAlone_55.webp": 15226,
	"./benjaminDehli_cantiquedeNoel_55.webp": 11515,
	"./benjaminDehli_cantiquedeNoelinstrumental_55.webp": 80631,
	"./benjaminDehli_lauraPalmersThemeCover_55.webp": 56517,
	"./benjaminDehli_rachelsSongCover_55.webp": 82790,
	"./benjaminDehli_twinPeaksThemeCover_55.webp": 38482,
	"./bjoernEidsvaagYlva_skyfriHimmel_55.webp": 15766,
	"./changemakers_veidemannen_55.webp": 87583,
	"./confusion_confusion_55.webp": 86494,
	"./confusion_escapeExplore_55.webp": 46960,
	"./confusion_fadeAway_55.webp": 1140,
	"./confusion_itsAllTooClear_55.webp": 37446,
	"./confusion_lettheGamesBegin_55.webp": 65364,
	"./confusion_thisTime_55.webp": 36463,
	"./esbenMeyer_taakemann_55.webp": 6237,
	"./grisene_julIgjen_55.webp": 64513,
	"./haaker_brothers_55.webp": 52945,
	"./haaker_guardianAngels_55.webp": 66731,
	"./haaker_rocknrolla_55.webp": 80979,
	"./hanneStaver_theWords_55.webp": 91553,
	"./hauntedBySilhouettesBjornSpeedStrid_selkie_55.webp": 41502,
	"./hauntedBySilhouettes_deadlock_55.webp": 68244,
	"./hauntedBySilhouettes_departure_55.webp": 68215,
	"./hauntedBySilhouettes_flock_55.webp": 27168,
	"./hauntedBySilhouettes_icon_55.webp": 61084,
	"./hauntedBySilhouettes_noManIsle_55.webp": 77661,
	"./hauntedBySilhouettes_theLastDayonEarth_55.webp": 49517,
	"./hauntedBySilhouettes_undertow_55.webp": 39535,
	"./kAASIN_carryOn_55.webp": 98373,
	"./kAASIN_chainofLove_55.webp": 82675,
	"./kAASIN_deadMansHand_55.webp": 47197,
	"./kAASIN_hidden_55.webp": 45163,
	"./kAASIN_insideOut_55.webp": 35327,
	"./kAASIN_revelation_55.webp": 70776,
	"./kAASIN_runawayTrain_55.webp": 6038,
	"./kAASIN_shadesofYesterday_55.webp": 38052,
	"./kAASIN_theSmokingGun_55.webp": 77854,
	"./kAASIN_walkingDownwards_55.webp": 16929,
	"./kAASIN_weAreOne_55.webp": 64885,
	"./kAASIN_wrong_55.webp": 61740,
	"./leneNevisdal_giveMeaSmileJoe_55.webp": 77530,
	"./setOnesCap_dontYouWannaKnow_55.webp": 81769,
	"./setOnesCap_likeaStone_55.webp": 39826,
	"./setOnesCap_waitfortheOther_55.webp": 62666,
	"./southofJameson_findmyshelterBonusTrackDemo_55.webp": 28420,
	"./southofJameson_littlegirlBonusTrackDemo_55.webp": 36408,
	"./southofJameson_womaninmydreamsBonusTrackDemo_55.webp": 60739,
	"./spinningWheelsBandRandleCurrieJustinWilliamson_backWhen_55.webp": 5660,
	"./spinningWheelsBand_powerofaGrin_55.webp": 97198,
	"./staaleKaasin_totheTop_55.webp": 12940,
	"./taxiBear_koreaTown_55.webp": 43214,
	"./theWhiteDevil_getLucky_55.webp": 42726,
	"./thomasTveiten_daaEDetVerdtDet_55.webp": 56999,
	"./wildWhens_backtrackJack_55.webp": 26946,
	"./wildWhens_chainsofYesterday_55.webp": 40454,
	"./wildWhens_crazytotheBoneRemastered_55.webp": 58556,
	"./wildWhens_crazytotheBone_55.webp": 73082,
	"./wildWhens_fromtheValley_55.webp": 83433,
	"./wildWhens_rebelHeart_55.webp": 83225,
	"./wildWhens_sailinSarah_55.webp": 60273,
	"./wildWhens_travellinMan_55.webp": 266,
	"./wolfMoonFever_diggingintoMyPast_55.webp": 72760,
	"./wolfMoonFever_seaofGreen_55.webp": 15462,
	"./wolfMoonFever_theKeeperoftheLighthouse_55.webp": 46396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32661;